import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cubActions from 'actions/cubActions';
import {
  Header,
  HeaderButtonNav,
  HeaderButton,
  HeaderTitle,
} from 'components/layout';
import * as operationsApi from 'api/operationsApi';
import { useNavigate } from 'react-router-dom';
import CubsListTable from './CubsListTable';
import Select from 'react-select';
import{Row,Col,FormGroup} from 'reactstrap'
import { Field } from 'redux-form';
import RenderField from 'components/fields/RenderField';

/*class TechnicianList extends Component {
  state = {
    showOverlay: false,
    loaded: false,
    technicians: []
  };

  componentDidMount() {
    operationsApi.getTechnicians().then(result => {
      this.setState({
        loaded: true,
        technicians: result.data
      });
    });
  }*/
const CubsList = (props) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [cubs, setCubs] = useState([]);
    const [allCubs, setAllCubs] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCubs = async () => {
      const result = await operationsApi.getCubs();
      console.log('result',result.data)
     setCubs(result.data);
     setAllCubs(result.data);
      setLoaded(true);
    };

    fetchCubs();
  }, []); // Empty dependency array means this runs once after the initial render

  const toggleNavigation = () => {
    this.setState((prevState) => ({
      showOverlay: !prevState.showOverlay,
    }));
  };

  const handleRowClick = (row) => {
    // this.props.history.push('/technicians/edit/' + row.id);
    navigate('/cubs/edit/' + row.cubserialnumber);
  };

  const handleCreateButtonClick = () => {
 console.log(cubs)
   navigate('/cubs/create');
  };

  if (!loaded) {
    return <div>Loading...</div>; // Render a loading state
  }

  const options = {
    onRowClick: handleRowClick,
  };

    const getSearch = searchString => {
      if(searchString==""){
        return setCubs(allCubs)
      }
      let result = allCubs.filter(item => item.cubshortname.includes(searchString))
      setCubs(result)
      
    };

  return (
    <div>
      <Header showLogo>
        <HeaderButtonNav>
          <HeaderButton
            color="primary"
            onClick={handleCreateButtonClick}
            ligature="add"
          />
        </HeaderButtonNav>
        <HeaderTitle label={'Cub Inventory'} />
      </Header>
      <Row>
        <Col className="col-sm-12">

                

                         <input
                                            label="SearchCubName"
                                            component={RenderField}
                                            placeholder="Search Cub Name"
                                       onChange={(e) => getSearch(e.target.value)} 
                                          />
        </Col>
                        </Row>
        <CubsListTable
              cubs={cubs}
              options={options}
              ownProps={props}
              action={props.action}
            />

    </div>
  );
};
//}

function mapStateToProps(state) {
  return { cubs: state.referenceData.cubs };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(cubActions, dispatch),
  };
}

export default  connect(mapStateToProps, mapDispatchToProps)(CubsList);
